<template>
  <div id="app">
    <div id="dialogHolder"></div>
    <div id="notifyPopup" ref="notifybarObj"></div>

    <router-view :key="mainKey" />
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script>
import Vue from "vue";

export default {
  computed: {
    mainKey() {
      return "main-" + this.$route.fullPath;
    },
    baseURL() {
      return process.env.BASE_URL;
    }
  },
  created() {
    Vue.prototype.$baseURL = process.env.BASE_URL;
  }
};
</script>
